import { Input, Switch } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { ISwitchInputProps } from './types';

function index(props: ISwitchInputProps) {

  const onCheckChange = (e: boolean) => {
    if(e) props.onChange(props.options.check)
    if(!e) props.onChange(props.options.uncheck)
  }

  return (
    <div className="input-component">
      {props.label && 
        <div className="input-component__label">
          {props.label}
        </div>
      }
      <div className="input-component__input">
        <Switch
          checkedChildren={<><CheckOutlined /> <strong> {props.checkedText || ''} </strong></>}
          unCheckedChildren={<><CloseOutlined /> <strong>{props.uncheckedText || ''}</strong></>}
          defaultChecked={props.defaultChecked}
          onChange={onCheckChange}
          disabled={props.disabled}
          checked={props.value === props.options.check}
        />
      </div>
    </div>
  )
}

export default index